<template>
  <router-view />
</template>

<script>
  import Vue from 'vue'
  import { mapActions, mapGetters } from 'vuex'
  import Path from '@/utilities/bid/enums/Path'

  export default Vue.extend({
    name: 'App',
    computed: {
      ...mapGetters('Auth', ['isLoggedIn']),

      currentPath: vm => vm.$route.path,
    },
    watch: {
      isLoggedIn(value) {
        this.redirectToLogin(value)
      },
      currentPath() {
        this.redirectToLogin(this.isLoggedIn)
      },
    },
    created() {
      this.redirectToLogin(this.isLoggedIn)

      this.initializeTableSettings()
      this.updateTableSettingsStorage()
    },
    methods: {
      ...mapActions('Settings', ['initializeTableSettings', 'updateTableSettingsStorage']),

      redirectToLogin(isLoggedIn) {
        if (!isLoggedIn && this.$route.meta?.requiresAuth) {
          this.$router.push(Path.LOGIN)
        }
      },
    },
  })
</script>
